import { SyntheticEvent, useState } from 'react';
import { CoreTypography } from '@youscience/core';
import { AccordionDetails } from '@mui/material';

import TriangleRightIcon from '@images/triangle-right.svg?react';
import EditIcon from '@images/big-pencil.svg?react';
import DeleteIcon from '@images/bucket.svg?react';

import AreaCard from '../AreaCard';
import AreaDeleteMessage from '../AreaDeleteMessage';

import {
  sxStyles,
  StyledAccordion,
  StyledAccordionSummary,
  StyledActionsWrap,
  StyledAreaTitle,
  StyledCipCode,
  StyledActionIcon,
} from './AreasAccordion.styles';

export interface AreaProgramsAccordionProps {
  areaTitle: string;
  areaCipCode: number;
  areaPrograms: number[];
  onOpenEditAreaModal: () => void;
}

export const AreasAccordion = (props: AreaProgramsAccordionProps) => {
  const { areaTitle, areaCipCode, areaPrograms, onOpenEditAreaModal } = props;

  const [isOpenAreaDeleteMessage, setIsOpenAreaDeleteMessage] = useState(false);

  const handleOpenAreaDeleteMessage = () => {
    setIsOpenAreaDeleteMessage(true);
  };

  const handleCloseAreaDeleteMessage = () => {
    setIsOpenAreaDeleteMessage(false);
  };

  const handleDelete = (event: SyntheticEvent) => {
    event.stopPropagation();
    handleOpenAreaDeleteMessage();
  };

  const handleEdit = (event: SyntheticEvent) => {
    event.stopPropagation();
    onOpenEditAreaModal();
  };

  return (
    <StyledAccordion>
      <StyledAccordionSummary expandIcon={<TriangleRightIcon />}>
        <StyledAreaTitle variant="h3" component="h2">
          {areaTitle}
        </StyledAreaTitle>

        <StyledActionsWrap>
          <StyledCipCode variant="h3" component="h2">{`CIP ${String(areaCipCode).padStart(2, '0')}`}</StyledCipCode>

          <StyledActionIcon onClick={handleDelete}>
            <DeleteIcon />
          </StyledActionIcon>

          <StyledActionIcon onClick={handleEdit}>
            <EditIcon />
          </StyledActionIcon>
        </StyledActionsWrap>
      </StyledAccordionSummary>

      <AccordionDetails sx={sxStyles.accordionDetails}>
        <CoreTypography variant="h4" component="h3">
          Related majors
        </CoreTypography>

        {areaPrograms.map((cipCode, index) => (
          <AreaCard key={cipCode + index} cipCode={cipCode} />
        ))}
      </AccordionDetails>

      {isOpenAreaDeleteMessage && (
        <AreaDeleteMessage
          isOpenAreaDeleteMessage={isOpenAreaDeleteMessage}
          onCloseAreaDeleteMessage={handleCloseAreaDeleteMessage}
          areaTitle={areaTitle}
          areaCipCode={areaCipCode}
        />
      )}
    </StyledAccordion>
  );
};
